import { render, staticRenderFns } from "./EddyCurrentSortingViz.vue?vue&type=template&id=ab215150&scoped=true"
import script from "./EddyCurrentSortingViz.vue?vue&type=script&lang=js"
export * from "./EddyCurrentSortingViz.vue?vue&type=script&lang=js"
import style0 from "./EddyCurrentSortingViz.vue?vue&type=style&index=0&id=ab215150&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab215150",
  null
  
)

export default component.exports